var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDownIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.592 12.9499L15.3004 8.23328C15.3785 8.15581 15.4405 8.06364 15.4828 7.96209C15.5251 7.86054 15.5469 7.75162 15.5469 7.64161C15.5469 7.5316 15.5251 7.42268 15.4828 7.32113C15.4405 7.21958 15.3785 7.12741 15.3004 7.04994C15.1442 6.89474 14.933 6.80762 14.7129 6.80762C14.4927 6.80762 14.2815 6.89474 14.1254 7.04994L9.95871 11.1749L5.83371 7.04994C5.67757 6.89474 5.46636 6.80762 5.24621 6.80762C5.02605 6.80762 4.81485 6.89474 4.65871 7.04994C4.57997 7.12712 4.51733 7.21916 4.47441 7.32072C4.4315 7.42229 4.40917 7.53136 4.40871 7.64161C4.40917 7.75187 4.4315 7.86094 4.47441 7.9625C4.51733 8.06406 4.57997 8.1561 4.65871 8.23328L9.36704 12.9499C9.44508 13.0345 9.53979 13.102 9.6452 13.1482C9.75062 13.1944 9.86446 13.2182 9.97954 13.2182C10.0946 13.2182 10.2085 13.1944 10.3139 13.1482C10.4193 13.102 10.514 13.0345 10.592 12.9499Z",
    fill: "#266071"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownIconBlue);
export default __webpack_public_path__ + "static/media/chevron_down_icon_blue.b0758fe5b6951d60fd763bb74258da18.svg";
export { ForwardRef as ReactComponent };